import apiFetch from '../apiFetch'

export default function (dossierId, token, lastAccessDate) {
  return apiFetch({ endPoint: `Dossier/Sale/DeleteFinance/${dossierId}`, method: 'DELETE', token: token, lastAccessDate })
}
